/**
 * AGC: Contract Owner Verification Hook
 * AGC: Checks if connected wallet is the contract owner
 * @author AGC (AI-Generated Code) with Cursor
 */

import { useAccount, useReadContract } from 'wagmi'

// AGC: StakingManagerV4 contract address
const STAKING_MANAGER_ADDRESS = (import.meta.env.VITE_STAKING_MANAGER_ADDRESS || '0x0000000000000000000000000000000000000000') as `0x${string}`

// AGC: Ownable ABI (owner function)
const OWNABLE_ABI = [
  {
    name: 'owner',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'address' }]
  }
] as const

/**
 * AGC: Hook to check if connected wallet is contract owner
 * @param contractAddress Optional contract address (defaults to StakingManager)
 * @returns { isOwner: boolean, ownerAddress: string | undefined, isLoading: boolean }
 */
export function useContractOwner(contractAddress?: `0x${string}`) {
  const { address, isConnected } = useAccount()
  const targetAddress = contractAddress || STAKING_MANAGER_ADDRESS

  // AGC: Read contract owner
  const { data: ownerAddress, isLoading } = useReadContract({
    address: targetAddress,
    abi: OWNABLE_ABI,
    functionName: 'owner',
    query: {
      enabled: isConnected && targetAddress !== '0x0000000000000000000000000000000000000000',
    },
  }) as { data: `0x${string}` | undefined; isLoading: boolean }

  // AGC: Check if connected address matches owner
  const isOwner = address && ownerAddress 
    ? address.toLowerCase() === ownerAddress.toLowerCase()
    : false

  return {
    isOwner,
    ownerAddress: ownerAddress || undefined,
    isLoading,
    isConnected
  }
}

